var map = {
	"./インターネット上の著作物等全般/bigMediaCategory": [
		64997,
		4997
	],
	"./冊子、パンフレット等/bigMediaCategory": [
		35587,
		5587
	],
	"./副読本、副教材等の教材/bigMediaCategory": [
		47040,
		7040
	],
	"./放送（テレビ・ラジオ）/bigMediaCategory": [
		83761,
		3761
	],
	"./教師用指導書及びその付属教材、指導者用デジタル教科書/bigMediaCategory": [
		9742,
		9742
	],
	"./新聞/bigMediaCategory": [
		17431,
		7431
	],
	"./映像DVD・ブルーレイ等/bigMediaCategory": [
		45422,
		5422
	],
	"./書籍・本/bigMediaCategory": [
		67655,
		7655
	],
	"./有線放送（ケーブルテレビ・有線ラジオ）/bigMediaCategory": [
		58042,
		8042
	],
	"./検定教科書/bigMediaCategory": [
		14407,
		4407
	],
	"./過去の試験問題/bigMediaCategory": [
		91626,
		1626
	],
	"./雑誌/bigMediaCategory": [
		80117,
		117
	],
	"./音楽/bigMediaCategory": [
		69011,
		9011
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 46797;
module.exports = webpackAsyncContext;